
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    brandImage() {
      if (!this.product.brand) return
      return this.product.brand.image
    }
  }
}
